import { Button } from '../../../legacy/hui/src/styled/';
import { Theme } from './Theme';
import { darken } from 'polished';
import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';

const ButtonBase = Button.extend`
  font-size: 14px;
  min-width: 64px;
  padding: 12px;
  border-radius: 5px;
  &:active,
  &:hover,
  &:focus {
    border-radius: 5px;
  }
`;

export const ButtonReverse = ButtonBase.extend`
  background: #fff;
  color: ${Theme.primary};
  &:active,
  &:hover,
  &:focus {
    background-color: ${darken(0.05, '#fff')};
  }
`;

export const ButtonAction = ButtonBase.extend`
  color: #fff;
  background-color: ${Theme.primary};
  &:active,
  &:hover,
  &:focus {
    background-color: ${darken(0.1, Theme.primary)};
  }
`;

export const ButtonSubmit = ButtonAction.extend`
  width: 100%;
`;

export const ButtonRemove = Button.extend`
  font-size: 11px;
  max-width: 80px;
  padding: 4px 23px 2px 10px;
  color: #a1a1a3;
  background-color: #ececec;
  &:active,
  &:hover,
  &:focus {
    background-color: ${darken(0.1, '#ececec')};
  }
  border: none;
  margin-left: 20px;
`;

class AnotherInstallButton extends React.Component {
  static propTypes = {
    url: PropTypes.string,
    history: PropTypes.object
  };

  clickHandler() {
    this.props.history.push(this.props.url);
  }

  render() {
    return (
      <ButtonSubmit tag="a" block mt={1} onClick={() => this.clickHandler()}>
        Enter another install code
      </ButtonSubmit>
    );
  }
}

export default withRouter(AnotherInstallButton);
